<div class="container" [attr.data-testid]="ELEMENT_IDS['page']">
  <div class="content">
    <div class="title">
      <h6 i18n [attr.data-testid]="ELEMENT_IDS['lbl_title']">Update Password</h6>
    </div>
    <p class="subtitle" i18n [attr.data-testid]="ELEMENT_IDS['lbl_subtitle']">Update the password of your new account.</p>
    <form
      class="form"
      [formGroup]="formUpdatePassword"
      (ngSubmit)="onSubmit()"
      novalidate
      [attr.data-testid]="ELEMENT_IDS['form']"
    >
      <app-custom-input
        label="New Password"
        controlName="newPassword"
        icon="lock"
        iconPlacement="left"
        [type]="showNewPassword ? 'text' : 'password'"
        [actionIcon]="showNewPassword ? 'visibility' : 'visibility_off'"
        [actionElementId]="ELEMENT_IDS['btn_toggle_new_password']"
        (onActionClick)="toggleShowPassword('new-password')"
        [elementId]="ELEMENT_IDS['input_new_password']"
      >
        <ng-template #errorsTemplate />
      </app-custom-input>

      <app-custom-input
        label="Confirm Password"
        controlName="confirmPassword"
        icon="lock"
        iconPlacement="left"
        [type]="showConfirmPassword ? 'text' : 'password'"
        [actionIcon]="showConfirmPassword ? 'visibility' : 'visibility_off'"
        [actionElementId]="ELEMENT_IDS['btn_toggle_confirm_password']"
        (onActionClick)="toggleShowPassword('confirm-password')"
        [elementId]="ELEMENT_IDS['input_confirm_password']"
      >
        <ng-template #errorsTemplate />
      </app-custom-input>

      @if (errorMessage) {
        <p class="error-message" @fadeInOut [attr.data-testid]="ELEMENT_IDS['msg_error']">{{errorMessage}}</p>
      }

      <ul class="requirement-list" [attr.data-testid]="ELEMENT_IDS['lst_requirements']">
      @for (requirement of passwordRequirements; track requirement.description; let i = $index) {
        <li [attr.data-testid]="ELEMENT_IDS['lst_requirements_item'] + '_' + i">
          <div class="requirement-list-item">
            <!-- Using interpolation on the icon's value causes odd behavior... -->
            @if (requirement.valid) {
              <mat-icon [attr.data-testid]="ELEMENT_IDS['lst_requirements_icon'] + '_' + i" [className]="requirement.valid ? 'requirement-list-item valid' : 'requirement-list-item invalid'" matListItemIcon>check_circle</mat-icon>
            }
            @else {
              <mat-icon [attr.data-testid]="ELEMENT_IDS['lst_requirements_icon'] + '_' + i" [className]="requirement.valid ? 'requirement-list-item valid' : 'requirement-list-item invalid'" matListItemIcon>remove_circle</mat-icon>
            }
            <span [attr.data-testid]="ELEMENT_IDS['lst_requirements_lbl'] + '_' + i">{{ requirement.description }}</span>
          </div>
        </li>
      }
      </ul>

      <app-custom-button
        [elementId]="ELEMENT_IDS['btn_update_password']"
        buttonType="primary"
        text="Update Password"
        [loading]="loading"
        [disabled]="formUpdatePassword.invalid"
        [isSubmit]="true"
      ></app-custom-button>

      <app-custom-button
        [elementId]="ELEMENT_IDS['btn_back']"
        buttonType="tertiary"
        text="Back to Login"
        [loading]="loading"
        (onClick)="onBackToLogin()"
      ></app-custom-button>
    </form>
  </div>
</div>
